import { render } from "./BzSlider.vue?vue&type=template&id=0a6d7064&scoped=true"
import script from "./BzSlider.vue?vue&type=script&lang=js"
export * from "./BzSlider.vue?vue&type=script&lang=js"

import "./BzSlider.vue?vue&type=style&index=0&id=0a6d7064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6d7064"]])

export default __exports__